import React, { Component } from 'react'


export default class SuccessMessage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            activeSuccess: false,
            timeout: 3000,
        }

        this.translation = JSON.parse(localStorage.translation)[
            localStorage.language
        ]
    }

    showMessage = () => {
        this.setState({
            activeSuccess: true,
        });
        this.closeMessage();
    }

    closeMessage = () => {
        setTimeout(
            () =>
                this.setState({
                    activeSuccess: false,
                }),
            this.state.timeout
        )
    }

    render() {
        return <div
            className={`success_message ${
                this.state.activeSuccess ? 'active' : ''
                }`}
        >
            <p>{this.translation[this.props.successMessage]}</p>
        </div>;
    }
}